import React, { useCallback, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { AppView, SCREEN_BOTTOM_PADDING, SettingsItem, SettingsSection, Spacer, withAnimatedNavigationHeader, } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { IconLocation, IconUser } from 'design-system/icons';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { IconTwoUser } from 'design-system/icons/IconTwoUser';
import { isWeb } from '../../../constants';
const strings = {
    headerTitle: 'Your identity',
    personalDetails: 'Personal details',
    address: 'Linked addresses',
    FinancialConnections: 'Financial connections',
    otherNames: 'Other names',
};
const CreditReportIdentityScreen = withAnimatedNavigationHeader(({ scrollHandler, navigation }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, [navigation]);
    const handlePress = useCallback((type) => {
        navigation.navigate('CreditReportIdentityDetailScreen', {
            type,
        });
    }, [navigation]);
    return (<AppView withFrame={false}>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} showsVerticalScrollIndicator contentContainerStyle={contentContainerStyle}>
            <Spacer.H8 />
            <SettingsSection noMarginTop>
              <SettingsItem title={strings.personalDetails} icon={<IconUser gradientKey="darkPurple"/>} onPress={() => handlePress('personal')}/>
              <SettingsItem title={strings.address} icon={<IconLocation alt gradientKey="yellow"/>} onPress={() => handlePress('address')}/>
              <SettingsItem title={strings.FinancialConnections} icon={<IconTwoUser alt gradientKey="skyBlue"/>} onPress={() => handlePress('financialConnections')}/>
              <SettingsItem title={strings.otherNames} icon={<IconUser gradientKey="darkPurple"/>} onPress={() => handlePress('otherNames')}/>
            </SettingsSection>
          </Animated.ScrollView>
        </AppView>);
}, ({ colors }) => ({
    title: strings.headerTitle,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default CreditReportIdentityScreen;
